// extracted by mini-css-extract-plugin
export default {"recTable":"recTable__BK3rD","head":"head__jKfc0","last":"last__+OGpD"};